<template>
  <div>
      <agile class="main" ref="main" :key="slides.length" :options="options1" :as-nav-for="asNavFor1">
        <div class="slide" v-for="(slide, index) in slides" :key="index" :class="`slide--${index}`"><img :src="slide"/></div>
      </agile>
      <agile class="thumbnails" ref="thumbnails" :key="slides.length" :options="options2" :as-nav-for="asNavFor2">
        <div class="slide slide--thumbniail" v-for="(slide, index) in slides" :key="index" @click="$refs.thumbnails.goTo(index)" :class="`slide--${index}`" ><img :src="slide"/></div>
<!--        <template slot="prevButton">AA<i class="fas fa-chevron-left"></i></template>
        <template slot="nextButton">AA<i class="fas fa-chevron-right"></i></template>-->
      </agile>
  </div>
  
</template>

<script>
import { VueAgile } from 'vue-agile'

export default {
  name: 'Slides',
  components: {
    agile: VueAgile 
  },
  props: ['slides'],
  data() {
    return {
			asNavFor1: [],
			asNavFor2: [],
			options1: {
				autoplay: false,
				//dots: false,
				fade: false,
				navButtons: false
			},
			
			options2: {
				autoplay: false,
				centerMode: true,
				dots: false,
				navButtons: false,
				slidesToShow: 3,
				responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        navButtons: true
                    }
                }
            ]
			},			
      //slides: [],
    }
  },
  created() {
  },
	async mounted () {
    this.asNavFor1.push(this.$refs.thumbnails)
    this.asNavFor2.push(this.$refs.main)
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
